import { forwardRef } from "react";
import { string } from "prop-types";
import { PinnableCell, HeaderRow, useEstimateTableSettings } from "@tools";
import { Grid } from "@material-ui/core";
import { TableHeaderCell } from "./components/TableHeaderCell";

export const TableHeader = forwardRef(({ tableIdentifier }, ref) => {
  const { timelineLength } = useEstimateTableSettings();
  
  return (
    <HeaderRow
      ref={ref}
      id={tableIdentifier}
      className="tableHeaderContainer preset-paperTimeline"
      actionPresetClass="preset-paperTimeline"
    >
      <PinnableCell
        pinnedLeft
        hasStaticWidth
        allowOverflowDisplay
        isHeader
      />
      <Grid item container wrap="nowrap" className="month-container w-max">
        {
          [...new Array(timelineLength).keys()]
            .map((i) => (
              <TableHeaderCell
                key={`month${i}`}
                monthIndex={i}
              />
            ))
        }
      </Grid>
    </HeaderRow>
  )
});

TableHeader.propTypes = {
  tableIdentifier: string.isRequired,
};
